import { httpWithAuth } from '~/clients';
import { GET_USER_PROFILE } from '~/constants/endpoints';
import { userProfile } from '~/queries';

type UserProfileResponse = {
  data: {
    userProfile: {
      profile: {
        customerId: string;
      };
    };
  };
};

export default function fetchUserProfile(controller: AbortController) {
  return httpWithAuth
    .post<UserProfileResponse>(
      GET_USER_PROFILE,
      { query: userProfile },
      {
        headers: {
          'apollographql-client-name': process.env.npm_package_name ?? '',
          'apollographql-client-version': process.env.npm_package_version ?? ''
        },
        signal: controller.signal
      }
    )
    .then(res => res.data.data.userProfile.profile);
}
